import { NativeDateAdapter } from '@angular/material/core';
import { CommonService } from '../services/common.service';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CustomDateAdapter extends NativeDateAdapter {
    private dateFormat: string; // 'dd/MM/yyyy', 'MM/dd/yyyy', or 'yyyy-MM-dd'

    constructor(private commonService: CommonService) {
        super();
        this.dateFormat = localStorage.getItem("date-format") ?? "";
    }

    setDateFormat(format: string) {
        this.dateFormat = format;
    }

    override getFirstDayOfWeek(): number {
        return 1; // Monday
    }

    parse(value: any): Date | null {
        if (typeof value === 'string') {
            const parts = value.split(/[-/]/); // Split on both '-' and '/'
            if (parts.length === 3) {
                let day: number, month: number, year: number;

                // Conditionally parse based on dateFormat
                if (this.dateFormat === 'dd/MM/yyyy') {
                    day = parseInt(parts[0], 10);
                    month = parseInt(parts[1], 10) - 1; // Months are 0-based
                    year = parseInt(parts[2], 10);
                } else if (this.dateFormat === 'MM/dd/yyyy') {
                    month = parseInt(parts[0], 10) - 1; // Months are 0-based
                    day = parseInt(parts[1], 10);
                    year = parseInt(parts[2], 10);
                } else if (this.dateFormat === 'yyyy/MM/dd') {
                    year = parseInt(parts[0], 10);
                    month = parseInt(parts[1], 10) - 1; // Months are 0-based
                    day = parseInt(parts[2], 10);
                } else {
                    return null; // Invalid format
                }

                // Validate month and day
                if (month >= 0 && month <= 11 && day > 0 && day <= this.getDaysInMonth(month, year)) {
                    return new Date(year, month, day);
                }
            }
        }
        return super.parse(value); // Fallback to default parsing if not valid
    }

    format(date: Date, displayFormat: Object): string {
        if (!date) {
            return '';
        }
        const day = date.getDate();
        const month = date.getMonth() + 1; // Months are 1-based
        const year = date.getFullYear();

        if (this.dateFormat === 'dd/MM/yyyy') {
            return `${day < 10 ? '0' : ''}${day}/${month < 10 ? '0' : ''}${month}/${year}`;
        } else if (this.dateFormat === 'MM/dd/yyyy') {
            return `${month < 10 ? '0' : ''}${month}/${day < 10 ? '0' : ''}${day}/${year}`;
        } else if (this.dateFormat === 'yyyy/MM/dd') {
            return `${year}/${month < 10 ? '0' : ''}${month}/${day < 10 ? '0' : ''}${day}`;
        }

        return `${day}/${month}/${year}`; // Default case, can be adjusted as necessary
    }

    private getDaysInMonth(month: number, year: number): number {
        // Handle leap year
        return new Date(year, month + 1, 0).getDate();
    }
}
